module.exports = __webpack_public_path__ + "img/stateRight.d1784ab9.svg";